module.exports = __webpack_public_path__ + "img/section3-pg.52106cf5.png";